import { useQuery } from '@tanstack/react-query';

import getRole from 'Api/role/getRole';

import getRoleRequest from './model/request/getRoleRequest';
import getRoleResponse from './model/response/getRoleResponse';

const useGetRole = (filter) => {
  return useQuery({
    queryKey: ['role', filter],
    queryFn: async () => {
      const queries = getRoleRequest(filter);

      const response = await getRole(queries);

      return getRoleResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetRole;
